<div class="c-cms-form" sk-field="{{field.fieldName}}">
    <div class="form-flex" skf-if="$field.fieldInfo.fieldExtraType != 10">
        <div class="form-label">{{if field.required == 1}}<span class="form-required">*</span>{{/if}}{{field.displayName}}</div>
        <div class="form-value">
            <div class="form-row u-pt8">
                {{each field.listOptions}}
                <div class="form-row">
                    <label class="c-form-radio">
                        <input type="radio" class="radio-input" name={{field.fieldName}} skf-options="{{$index}}" skf-checked="$value.checked"
                               skf-change="$parent.changeList({{$value.optionId}}, '{{field.fieldName}}')"/>
                        <span class="radio-icons"></span>
                        <span class="radio-text">{{$value.optionValue}}</span>
                        {{if $value.otherisFillIn == 1}}
                        <input type="text" class="radio-other" skf-options="{{$index}}" skf-value="$value.otherValue" skf-change="$parent.changeListOtherValue({{$value.optionId}}, '{{field.fieldName}}')" />
                        {{/if}}
                    </label>
                    <div class="form-error" skf-options="{{$index}}" skf-if="$value.checked && $value.dirty && $value.otherisFillIn == 1 && $value.otherIsRequire == 1 && !$value.otherValue">请填写</div>
                </div>
                {{/each}}
            </div>
            <div class="form-error" skf-if="$field.dirty && $field.invalid" skf-text="$field.validationMessage"></div>
        </div>
    </div>
    <div class="form-flex" skf-if="$field.fieldInfo.fieldExtraType == 10">
        <div class="form-label"></div>
        <div class="form-value">
             <div class="form-row u-pt8">
                <div class="form-row">
                    <label class="c-form-checkbox">
                        <input type="checkbox" name={{field.fieldName}}
                               skf-change="$parent.changePolicy('{{field.fieldName}}')"
                               skf-checked="$field.isSelected"/>
                        <span class="checkbox-icons"></span>
                        <div class="checkbox-text" skf-html="$field.fieldInfo.privacyPolicyTitle"></div>
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>